import { OnInit, Component } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpErrorResponse } from '@angular/common/http';
import { NzNotificationService } from 'ng-zorro-antd';

import { GlobalComponent, Result, Aziende, Ordine } from '../../environments/global';

@Component({
    selector: 'app-mese-report',
    templateUrl: 'mese-report.html',
    styleUrls: ['mese-report.scss'],
    providers: [DatePipe]
})
export class MeseReportComponent implements OnInit {
    // TABLE VARS
    daysData = [];
    timesData = [];
    usersData = [];
    editCache = {};
    sortName = null;
    sortValue = null;
    // COMPONNET VARS
    companyData: Array<string> = Aziende;
    isSpinning: boolean = false;
    isLoading: boolean = false;
    selectedCompany: string;
    selectedMonth: Date;
    public selectedMonthName: string;
    currentTotale: string;
    dateFormat = 'dd/MM/yyyy';

    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(
        public g: GlobalComponent,
        private datepipe: DatePipe,
        private notification: NzNotificationService) {
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 9;
        this.g.homeTitle = 'Report Mese';
    }
    selectUsers() {
        this.isSpinning = true;
        const query: string = 'SELECT * from chk_users';
        this.g.mysql(query)
            .subscribe((res: Result) => {
                this.usersData = res.data;
                this.isSpinning = false;
            }, (error: HttpErrorResponse) => {
                this.isSpinning = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
            });
    }
    loadTimes() {
        this.isLoading = true;
        let startDate: Date;
        let endDate: Date;
        // tslint:disable-next-line:max-line-length
        let query: string = 'SELECT chk_times.userId, chk_times.date, Round(Sum(chk_times.h),2) AS Sum_h, chk_users.name, chk_users.surname FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId';
        
        if (this.selectedMonth != null) {
            startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
            endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);

            query += ' WHERE chk_times.date >= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
                ' AND chk_times.date <= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '"';
            this.selectedMonthName = this.selectedMonth.toLocaleString('it-IT', { month: 'long' });
        }

        query += ' GROUP BY chk_times.userId, chk_times.date, chk_users.name, chk_users.surname ORDER BY chk_times.date, chk_times.userId';
        console.log(query);
        
        return this.g.mysql(query)
            .subscribe((res: Result) => {
                this.isLoading = false;
                this.timesData = res.data;

                const endtDay = endDate.getUTCDate();
                this.daysData = [];
                for (let nday: number = 1; nday <= endtDay + 1; nday++) {
                    this.daysData.push({ day: nday, users: this.deepCopy(this.usersData), expand: true });
                }

                console.log(this.daysData);
                // console.log(this.timesData);
                let nTot: number = 0;

                this.timesData.forEach(t => {
                    const data: Date = new Date(t.date);
                    const day: number = data.getDate();

                    const item = this.daysData[day - 1].users.find(u => u.id === t.userId);
                    item.Sum_h = t.Sum_h;
                    nTot += t.Sum_h;
                });
                this.currentTotale = (nTot > 0) ? 'Totale ore: ' + nTot : '';
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
            });
    }
    deepCopy(obj) {
        let copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' !== typeof obj) { return obj; }

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = this.deepCopy(obj[attr]);
                }
            }
            return copy;
        }

        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }

    // sort(sort: { key: string, value: string }): void {
    //     this.sortName = sort.key;
    //     this.sortValue = sort.value;
    //     if (this.sortName) {
    //         this.displayData = [... this.timesData.sort((a, b) => (this.sortValue === 'ascend') ?
    //             (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
    //     } else {
    //         this.displayData = [...this.timesData];
    //     }
    // }

    copyToClipboard() {
        let xls: string = '';

        this.daysData.forEach(d => {
            d.users.forEach(u => {
                xls += d.day.toString()  + '/' + this.selectedMonth.getMonth() + '/' + this.selectedMonth.getFullYear() + '\t';
                xls += u.code + '\t';
                xls += u.name + '\t';
                xls += u.surname + '\t';
                xls += (u.Sum_h || 0) + '\r\n';
            });
        });


        const dummy = document.createElement('textarea');
        document.body.appendChild(dummy);
       // dummy.setAttribute('value', xls);
        dummy.value = xls;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

    }
}
